import content from '../../data/content.js';

import { Moon, Sun, Globe } from 'lucide-react';

import './Navbar.css';

const Navbar = ({ setView, lang, setLang, theme, toggleTheme }) => {
  const t = content[lang].nav;

  const handleNav = (id) => {
    setView('home');
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <nav className="navbar">
      <div className="nav-left">
        <div className="nav-logo-group" onClick={() => { setView('home'); window.scrollTo(0,0); }}>
          <span className="nav-name">Jakub Wawrzyniak</span>
          <span className="nav-year">Portfolio '26</span>
        </div>
      </div>

      <div className="nav-right">
        <div className="nav-controls">
          <button onClick={() => setLang(lang === 'en' ? 'pl' : 'en')} className="control-btn" title="Switch Language">
            <Globe size={16} />
            <span>{lang === 'en' ? 'EN' : 'PL'}</span>
          </button>
          <button onClick={toggleTheme} className="control-btn" title="Toggle Theme">
            {theme === 'light' ? <Sun size={16} /> : <Moon size={16} />}
          </button>
        </div>

        <div className="nav-links">
          <button onClick={() => handleNav('work')}>{t.work}</button>
          <button onClick={() => handleNav('about')}>{t.about}</button>
          <button onClick={() => handleNav('contact')}>{t.contact}</button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;